<template>
  <Modal :open="open" size="medium" @close="$emit('close')">
    <div class="pr-6">
      <h2 class="text-lg font-bold text-gray-900 border-b border-gray-200 pb-2 mb-4">
        Qu'est-ce que le cumul d'assurance ?
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-5">
        C'est le fait d'être assuré plusieurs fois pour le même appareil ou pour les mêmes risques.
      </p>

      <section class="mb-5">
        <h3 class="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
          <span class="w-1.5 h-1.5 rounded-full bg-primary" />
          Avant de souscrire
        </h3>
        <p class="text-sm text-gray-600 leading-relaxed pl-3.5">
          Avant de choisir cette assurance, il est important de vérifier si vous ne bénéficiez pas déjà d'une couverture
          identique ou similaire. Cela permet d'éviter un cumul involontaire.
        </p>
      </section>

      <section class="mb-5">
        <h3 class="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
          <span class="w-1.5 h-1.5 rounded-full bg-primary" />
          Ce que cela implique
        </h3>
        <ul class="text-sm text-gray-600 leading-relaxed pl-3.5 space-y-1.5 list-none">
          <li class="flex gap-2">
            <span class="text-primary mt-0.5">•</span>
            <span>Les garanties peuvent se recouvrir, se compléter ou faire double emploi.</span>
          </li>
          <li class="flex gap-2">
            <span class="text-primary mt-0.5">•</span>
            <span>Vous pouvez payer plusieurs cotisations alors qu'une seule assurance pourrait suffire.</span>
          </li>
          <li class="flex gap-2">
            <span class="text-primary mt-0.5">•</span>
            <span>
              En cas de sinistre, le total des indemnisations ne pourra jamais dépasser la valeur de l'appareil assuré.
            </span>
          </li>
        </ul>
      </section>

      <section class="p-3 rounded-lg border">
        <h3 class="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
          <span>!</span>
          Bon à savoir
        </h3>
        <p class="text-sm text-gray-700 leading-relaxed">
          Si vous souhaitez compléter une assurance existante, vous devez informer chaque assureur de l'existence de
          l'autre contrat et du niveau de garantie associé.
        </p>
      </section>
    </div>
  </Modal>
</template>

<script>
import { Modal } from "@estaly/ui";

export default {
  name: "ExistingInsuranceModal",
  components: { Modal },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
};
</script>
